import { castEnum, castOptionalEnum } from "../../../../utils/CommonUtils";
import { DocsBlockItemVariantLayoutAlign } from "../../../enums/SDKDocsBlockItemVariantLayoutAlign";
import { DocsBlockItemVariantLayoutColumnResizing } from "../../../enums/SDKDocsBlockItemVariantLayoutColumnResizing";
import { DocsBlockItemVariantLayoutGap } from "../../../enums/SDKDocsBlockItemVariantLayoutGap";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocsBlockLayout {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c;
        this.type = castEnum(model.type);
        this.children = model.children.map((child) => {
            if (typeof child === "string") {
                return child;
            }
            return new DocsBlockLayout(child);
        });
        this.type = castEnum(model.type);
        this.columnAlign =
            (_a = castOptionalEnum(model.columnAlign)) !== null && _a !== void 0 ? _a : DocsBlockItemVariantLayoutAlign.start;
        this.columnResizing =
            (_b = castOptionalEnum(model.columnResizing)) !== null && _b !== void 0 ? _b : DocsBlockItemVariantLayoutColumnResizing.fill;
        this.gap =
            (_c = castOptionalEnum(model.gap)) !== null && _c !== void 0 ? _c : DocsBlockItemVariantLayoutGap.medium;
    }
}
